// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"760a1976","682":"6621d6cf","852":"589e7c5b","1483":"380a1e70","4497":"dd7d0c83","5596":"6621d6cf","7636":"6621d6cf","8610":"dd7d0c83"}[chunkId] + ".chunk.css";
};